type ParseUserAgentParams = {
  userAgent: string;
};

type ParsedUserAgent = {
  displayText: string;
  type: 'mobile' | 'desktop';
};

const browserMatchers = [
  { name: 'Edge', pattern: /Edg(e|A|iOS)?\// },
  { name: 'Opera', pattern: /OPR\/|Opera/ },
  { name: 'Samsung Browser', pattern: /SamsungBrowser/ },
  { name: 'Firefox', pattern: /Firefox/ },
  { name: 'Safari', pattern: /^(?!.*(?:Chrome|Chromium|CriOS)).*Safari/ },
  { name: 'Chrome', pattern: /Chrome|CriOS/ },
] as const;

const mobileOsNames = new Set(['iPhone', 'iPad', 'Android']);

const osMatchers = [
  { name: 'iPhone', pattern: /iPhone/ },
  { name: 'iPad', pattern: /iPad/ },
  { name: 'Android', pattern: /Android/ },
  { name: 'Windows', pattern: /Windows/ },
  { name: 'macOS', pattern: /Macintosh|Mac OS X/ },
  { name: 'Linux', pattern: /Linux/ },
  { name: 'ChromeOS', pattern: /CrOS/ },
] as const;

export const parseUserAgent = ({
  userAgent,
}: ParseUserAgentParams): ParsedUserAgent | null => {
  if (!userAgent?.trim()) {
    return null;
  }

  const browser = browserMatchers.find(({ pattern }) =>
    pattern.test(userAgent),
  )?.name;

  const os = osMatchers.find(({ pattern }) => pattern.test(userAgent))?.name;

  if (!browser && !os) {
    return null;
  }

  const isMobile = os ? mobileOsNames.has(os) : false;

  const displayText =
    browser && os ? `${browser} on ${os}` : (browser ?? os ?? '');

  return {
    displayText,
    type: isMobile ? 'mobile' : 'desktop',
  };
};
